import {config as coreConfig} from '@netx/core-next/config';
import {currentPortal} from '@netx/core-cms/singletons';

export const config = {
	...coreConfig,
	get HOME_ROUTE() {
		// Set home route if it exists
		return currentPortal.get('homeRoute')
			? '#page/' + currentPortal.get('homeRoute')
			: '#';
	},
	get REQUIRE_LOGIN() {
		const requireLogin = currentPortal.get('requireLogin');
		if (requireLogin != null && requireLogin == false) {
			return false;
		}
		return true;
	},
};

export default config;
